import React, { Component } from "react";
import { Input } from "reactstrap";

export default class EditDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.row.type_name,
    };
  }

  render() {
    const { row } = this.props;

      return (
        <Input
          type="text"
          disabled={true}
          value={this.state.type}
          onChange={(e) => this.setState({type: e.target.value})}
          onBlur={() => this.props.handleSave(row.id, this.state.type)}
        />
      );
    }
}
